import { ActionType, ISmartFastEntriesActionEvent } from "@components/smart/smartFastEntryList";
import { ISmartFieldBlur, ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrBenefitEntity } from "@odata/GeneratedEntityTypes";
import { handleCurrentTemporalPropChange } from "@odata/TemporalUtils";
import {
    getBankBlurArgs,
    handleBankFieldChangeWithoutSavedAccount
} from "@pages/banks/bankAccounts/BankAccounts.utils";
import {
    handleTaxAndContributionsApplicabilityChange,
    recalculateBenefitMealVoucherAmounts
} from "@pages/payroll/benefits/Benefit.utils";
import { ADD_EMPLOYEE_ITEM } from "@pages/payroll/deduction/Deduction.utils";
import { handleBankAccountOrIBANBlur } from "@utils/BankUtils";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { IFormStorageDefaultCustomData } from "../../../views/formView/FormStorage";
import { FormViewForExtend, IFormViewProps } from "../../../views/formView/FormView";

interface IBenefitCustomData extends IFormStorageDefaultCustomData {
    pairedDialogOpened?: boolean;
}

class BenefitFormView extends FormViewForExtend<IPrBenefitEntity, IFormViewProps<IPrBenefitEntity, IBenefitCustomData>> {
    static contextType = AppContext;
    static defaultProps = {
        title: "Benefit:Form.Title",
        formProps: {
            shouldHideAuditTrail: true,
        }
    };

    async onAfterLoad(): Promise<void> {
        const storage = this.props.storage.getThis();
        const bindingContext = this.props.storage.data.bindingContext;

        if (bindingContext.isNew()) {
        }
        return super.onAfterLoad();
    }

    handleCustomLineItemAction = async (args: ISmartFastEntriesActionEvent): Promise<void> => {
        if (args.customActionType === ADD_EMPLOYEE_ITEM) {
            this.props.storage.setCustomData({ pairedDialogOpened: true });
            this.props.storage.refresh();
        }
    };

    handleLineItemsAction = async (args: ISmartFastEntriesActionEvent): Promise<void> => {
        if (args.actionType === ActionType.Custom) {
            await this.handleCustomLineItemAction(args);
            return;
        }
        this.props.storage.handleLineItemsAction(args);
        this.props.storage.refresh();
    };

    handleChange = (e: ISmartFieldChange): void => {
        const storage = this.props.storage.getThis();
        storage.handleChange(e);

        handleBankFieldChangeWithoutSavedAccount({ storage }, e);
        handleTaxAndContributionsApplicabilityChange(storage, e);

        handleCurrentTemporalPropChange(e, storage);
        storage.refreshFields(e.triggerAdditionalTasks);
    };

    handleSmartTemporalPropertyDialogBlur(args: ISmartFieldBlur): void {
        recalculateBenefitMealVoucherAmounts(this.props.storage, args);
    }

    handleBlur = async (args: ISmartFieldBlur): Promise<void> => {
        await super.handleBlur(args);
        if (args.wasChanged) {
            handleBankAccountOrIBANBlur(getBankBlurArgs(this.props.storage.getThis(), args.bindingContext));
            recalculateBenefitMealVoucherAmounts(this.props.storage, args);
            this.props.storage.refreshFields();
        }
    }

    // for overload in heirs
    onBeforeSave(data?: IPrBenefitEntity): IPrBenefitEntity {
        data = data ?? this.entity;
        return data;
    }
}

export default withPermissionContext(BenefitFormView);